export const messages = {
  en: {
    message: {
      auth: "Authentication",
      wifiTitle: "Wi-Fi connection",
      wifiText: "For using internet connection, please type your phone number",
      wifiTypeCall: "by voicecall",
      wifiTypeSMS: "by SMS",
      wifiConsent: "By continuing, you agree to our terms of service",
      wifiSessionClosed: "Session closed",
      wifiStatusSuccess:
        "Access granted. Now you connected to free Wi-Fi network.",
      wifiSigninText: "Welcome to free Wi-Fi network",
      wifiSigninBtn: "Browse the internet",
      wifiEnterCode: "Enter the code you received in the proper field.",
      next: "Next"
    }
  },
  ru: {
    message: {
      auth: "Авторизация",
      wifiTitle: "Подключение к Wi-Fi",
      wifiText: "Для получения доступа к интернету введите свой номер телефона",
      wifiTypeCall: "по звонку",
      wifiTypeSMS: "по СМС",
      wifiConsent:
        "Продолжая, вы принимаете условия пользовательского соглашения",
      wifiSessionClosed: "Сессия завершена",
      wifiStatusSuccess:
        "Доступ подтвержден. Вы подключились к беспроводной сети Wi-Fi.",
      wifiSigninText: "Добро пожаловать в зону бесплатного Wi-Fi",
      wifiSigninBtn: "Перейти в интернет",
      wifiEnterCode:
        "Введите полученный Вами код доступа в соответствующее поле.",
      next: "Далее"
    }
  }
};
